import { render, staticRenderFns } from "./SourceCode.vue?vue&type=template&id=0a6d4c1f&scoped=true&"
import script from "./SourceCode.vue?vue&type=script&lang=ts&"
export * from "./SourceCode.vue?vue&type=script&lang=ts&"
import style0 from "./SourceCode.vue?vue&type=style&index=0&id=0a6d4c1f&scoped=true&lang=css&"
import style1 from "./SourceCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d4c1f",
  null
  
)

export default component.exports